import React, { useRef, useState } from "react";
import logo from "../assetes/logo.png";
import cat1 from "../assetes/cat1.jpeg";
import cat2 from "../assetes/cat2.jpeg";
import cat3 from "../assetes/cat3.jpeg";
import cate4 from "../assetes/cate4.jpeg";
import { BsCloudUpload } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { createPhotoForAccident } from "../redux/apiCalls/accidentApiCall";
import { ClipLoader } from "react-spinners";
function FotosPartner() {
  const {lastAccident, createPhotoLoading, partner} = useSelector(state => state.accident)
  const images = [logo, cat1, cat2, cat3, cate4];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch()
  const [image, setImage] = useState(null)
  const [imageText, setImageText] = useState("");
  const formData = new FormData();
  const fileInputRef = useRef(null);
  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % partner.user.photos.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + partner.user.photos.length) % partner.user.photos.length);
  };

  const handleUpload = () => {

    if(!image){
      return
    }

    formData.append("image", image)
    formData.append("kind", imageText);
    formData.append("user", partner.user._id)

    dispatch(createPhotoForAccident(formData, "partner"))
  }

  return (
    <>
     {partner.user.photos.length> 0?  <div className={`relative w-full h-screen bg-gray-100 flex items-center justify-center ${isModalOpen ? "blur-sm" : ""} transition-all duration-300`}>
        {/* الصورة الحالية */}
        
       {/* <div className="w-[250px] h-[300px] flex justify-center items-center overflow-hidden mb-[100px]">
          <img
            src={partner.user.photos[currentIndex].photo.url}
            alt={`Slide ${currentIndex}`}
            className="w-full h-full object-cover"
          />
        </div> */}


<div className="w-[300px] h-[350px] flex justify-center items-center overflow-hidden mb-[100px]">
  <img
    src={partner.user.photos[currentIndex].photo.url}
    alt={`Slide ${currentIndex}`}
    className="object-cover"
  />
</div>

        {/* زر الانتقال السابق */}
        <button
          onClick={handlePrev}
          className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black text-white rounded-full w-12 h-12 flex items-center justify-center opacity-50 hover:opacity-100 transition-opacity"
          style={{ zIndex: 10 }}
        >
          {"<"}
        </button>

        {/* زر الانتقال التالي */}
        <button
          onClick={handleNext}
          className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black text-white rounded-full w-12 h-12 flex items-center justify-center opacity-50 hover:opacity-100 transition-opacity"
          style={{ zIndex: 10 }}
        >
          {">"}
        </button>
      </div>:<div className="text-center mt-[10px] font-bold text-[20px]">There is no photos</div>}

      <div className="flex justify-center items-center mt-6 absolute bottom-[40px] left-[50%]">
        <button
          onClick={() => setIsModalOpen(true)}
          className="bg-[#DAA520] hover:bg-[#b8911a] text-black font-semibold py-2 px-4 border-[1px] border-[black] rounded shadow-md"
        >
          + Neue Fotos hochladen
        </button>
      </div>

      {/* النافذة المنبثقة */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-[#333] bg-opacity-[0.5] flex items-center justify-center z-50">
          <div
            className="bg-[rgb(237,237,235)] p-6 rounded-lg shadow-lg w-[600px] animate-fade-in-down"
            style={{ animationDuration: "0.3s" }}
          >
            <h2 className="text-lg font-bold mb-4 text-center">Daten Name</h2>
            <div className="flex items-center mb-4 justify-between">
<div className="flex items-center">
<input
                onChange={(e) => {
                  setImage(e.target.files[0])
              }}
                type="file"
                ref={fileInputRef}
                className="hidden"
                id="fileInput"
              />
                      <label
          htmlFor="fileInput"
          className="block text-sm text-gray-500 py-2 px-4 rounded-lg border border-gray-300 bg-blue-50 text-blue-700 hover:bg-blue-100 cursor-pointer"
        >
          Datei auswählen
        </label>
        <span id="fileName" className="ml-2 text-sm text-gray-500">
          Keine Datei ausgewählt
        </span>
</div>
               {createPhotoLoading ?<div className="bg-blue-500 font-[700] text-white px-4 py-2 rounded-r-md hover:bg-blue-600">
                <ClipLoader color="fff"/>
              </div> : <button onClick={handleUpload} className="bg-blue-500 font-[700] text-white px-4 py-2 rounded-r-md hover:bg-blue-600">
              UPLOAD
              </button>}
            </div>
            <input type="text" value={imageText} onChange={(e) => {setImageText(e.target.value)}} placeholder=" Name des Bildes" className="bg-[#fff] p-[10px] rounded-lg shadow-lg animate-fade-in-down outline-none w-[100%]"/>
            <div className="flex justify-center">
              <div className="text-blue-500 text-4xl">
                <i className="fas fa-cloud-upload-alt"></i>
              </div>
            </div>
            <div className="flex justify-center mt-4">
              <button
                onClick={() => setIsModalOpen(false)}
                className="bg-gray-300 px-4 py-2 rounded-md hover:bg-gray-400"
              >
                Close
              </button>
              <button
                className=" px-4 py-2 cursor-pointer bg-transparent"
              >
                <BsCloudUpload className="text-[29px] text-[#54d8fb] transition-all hover:text-blue-700" />
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default FotosPartner
